import { scCoreModule } from '../core/core.module';
import { scFilterModule } from '../filter/filter.module';
import { CatalogViewNodeComponent } from '../view/catalog/catalog-view-node.component';
import { CatalogViewComponent } from '../view/catalog/catalog-view.component';
import { FrameViewComponent } from '../view/frame-view.component';
import { QuadViewComponent } from '../view/quad-frames/quad-view.component';
import { QuadLastScreenshotsComponent } from '../view/quad-last-screenshots/quad-last-screenshots.component';
import { scFactsModule } from '../facts/facts.module';
import { scStatModule } from '../stat/stat.module';
import { scSharedModule } from '../shared/shared.module';
import { ReportFrameViewComponent } from './report-frame-view.component';
import { ViewComponent } from './view.component';
import { ViewTabsComponent } from './view-tabs.component';
import { DashboardComponent } from './dashboard/dashboard.component';
import { DashboardNodeComponent } from './dashboard/dashboard-node.component';
import { ResizeHandlerComponent } from './dashboard/resize-handler/resize-handler.component';
import { FilterPreviewComponent } from '../filter/editor/filter-preview/filter-preview.component';
import { CardComponent } from './dashboard/card.component';
import { CardAccountComponent } from './dashboard/card-account.component';
import { FilterViewComponent } from './filter-view.component';
import { OnScroll } from './chat-viewer/on-scroll.component';
import { ChatViewerNodeComponent } from './chat-viewer/chat-viewer-node.component';
import { ChatViewerComponent } from './chat-viewer/chat-viewer.component';
// import { CatalogViewSearchComponent } from '../view/catalog/catalog-view-search.component';
// import { CatalogNodeDragService } from '../view/catalog/catalog-node-drag.service';

export const scViewModule = 'sc-view';

angular.module(scViewModule, [
  scFactsModule,
  scStatModule,
  scCoreModule,
  scFilterModule,
  scSharedModule,
])
  // .service('CatalogNodeDragService', CatalogNodeDragService)
  // .component('scCatalogViewSearch', CatalogViewSearchComponent)
  .component('scCatalogViewNode', CatalogViewNodeComponent)
  .component('scCatalogView', CatalogViewComponent)
  .component('scQuadView', QuadViewComponent)
  .component('scQuadLastScreenshots', QuadLastScreenshotsComponent)
  .component('scFrameView', FrameViewComponent)
  .component('scReportFrameView', ReportFrameViewComponent)
  .component('scView', ViewComponent)
  .component('scViewTabs', ViewTabsComponent)
  .component('scDashboard', DashboardComponent)
  .component('scDashboardNode', DashboardNodeComponent)
  .component('scResizeHandler', ResizeHandlerComponent)
  .component('scFilterPreview', FilterPreviewComponent)
  .component('scCard', CardComponent)
  .component('scCardAccount', CardAccountComponent)
  .component('scFilterView', FilterViewComponent)
  .directive('onScroll', OnScroll)
  .directive('scChatViewerNode', ChatViewerNodeComponent)
  .component('scChatViewer', ChatViewerComponent)
;



// WEBPACK FOOTER //
// ./src/view/view.module.js